import script from "./ChartPageThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartPageThumbnail.vue?vue&type=script&setup=true&lang=ts"

import "./ChartPageThumbnail.vue?vue&type=style&index=0&id=1373e391&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1373e391"]])

export default __exports__